<template>
  <div class="page-container">
    <Filter :params="params" @search="searchData"></Filter>
    <Table :tableData="tableDataList" :total="data.total" :select="false" @update="updatePage">
      <el-table-column type="index" align="center" :label="$t('pages.indexNo')" width="60px" />
      <el-table-column prop="toEmail" :label="$t('system.emaillist.receiverEmail')" />
      <el-table-column prop="senderName" :label="$t('system.emaillist.sender')" />
      <el-table-column prop="subject" :label="$t('system.emaillist.subject')"/>
      <el-table-column prop="success" :label="$t('system.emaillist.status')" >
        <template #default="{row}">
          {{ row.success ? $t('system.emaillist.success') : $t('system.emaillist.failure') }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" :label="$t('system.emaillist.creationTime')" />
      <el-table-column prop="sendTime" :label="$t('system.emaillist.sendingTime')" />
      <el-table-column :label="$t('system.emaillist.operation')" fixed="right" width="120">
        <template #default="{row}" style="padding-bottom: 20px;">
          <el-button type="text" size="mini" :disabled="row.success" @click="handleDetail(row)">{{$t('system.emaillist.resend')}}</el-button>
          <el-button type="text" style="color: #f56c6c;" size="mini" @click="deleteDetail(row)">{{$t('system.emaillist.delete')}}</el-button>
        </template>
      </el-table-column>
    </Table>
  </div>
</template>

<script>
import { request } from "@/utils/request";
import { common } from "@/common/mixin";
import { ref, reactive } from "@vue/reactivity";
import Table from "@/components/table/index";
import Filter from "@/components/table/filter";
import { ElMessage, ElMessageBox } from "element-plus";
import { reqDeleteEmailSendLog } from "@/api/robot"
import { getUrlParam } from '@/common/utils'
import { useI18n } from 'vue-i18n'
export default {
  components: {
    Table,
    Filter,
  },
  mixins: [common],
  setup() {
    const { t } = useI18n()
    const emailConfigId = getUrlParam(window.location.href, 'id')
    const params = [
      {
        key: "toEmail",
        value: "",
        label: t('system.emaillist.receiverEmail'),
      },
      {
        key: "senderName",
        value: "",
        label: t('system.emaillist.sender'),
      },
      // {
      //   type: "Date",
      //   key: "dateRange",
      //   value: [],
      //   label: "创建日期",
      //   options: {
      //     "type": "datetimerange",
      //     "format": "YYYY-MM-DD HH:mm:ss",
      //     "value-format": "YYYY-MM-DD HH:mm:ss",
      //     "range-separator": "至",
      //     "start-placeholder": "开始日期",
      //     "end-placeholder": "结束日期",
      //     "default-time": [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)]
      //   }
      // },
      {
        type: "Date",
        key: "dateRange",
        value: [],
        label: t('system.emaillist.sendingDate'),
        options: {
          "type": "datetimerange",
          "format": "YYYY-MM-DD HH:mm:ss",
          "value-format": "YYYY-MM-DD HH:mm:ss",
          "range-separator": t('system.emaillist.to'),
          "start-placeholder": t('system.emaillist.startDate'),
          "end-placeholder": t('system.emaillist.endDate'),
          "default-time": [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)]
        }
      }
    ];
    var query = {
      emailConfigId: emailConfigId
    };
    const data = reactive({
      dialogFormVisible: false,
      dialogTitle: false,
      dialogTableVisible: false,
      page: 1,
      size: 10,
      total: 0,
    });
    const tableDataList = ref([]);

    const getData = async () => {
      console.log("query", query);
      try {
        const res = await request("requestEmailSendLogList", {
          ...query,
          startTime: query.dateRange?.[0],
          endTime: query.dateRange?.[1],
          page: data.page,
          size: data.size,
          emailConfigId: emailConfigId
        });
        console.log("requestList", res);
        tableDataList.value = res.records;
        data.total = res.total;
      } catch (error) {
        console.error(error);
      }
    };
    const searchData = (data) => {
      query = data;
      getData();
    };
    const updatePage = (page, size) => {
      data.page = page || 1;
      data.size = size || 10;
      getData();
    };
    const deleteDetail = async (row) => {
      try {
        await ElMessageBox.confirm(
          t('system.emaillist.confirmDelete'),
          {
            confirmButtonText: t('system.emaillist.confirm'),
            cancelButtonText: t('system.emaillist.cancel'),
            type: 'warning',
          }
        )
        await reqDeleteEmailSendLog(row.id)
        ElMessage({
          showClose: true,
          type: "success",
          message: t('system.emaillist.deleteSuccess')
        })
        getData()
      } catch (error) {
        console.error(error)
      }
    }
    const handleDetail = async (row) => {
      try {
        console.log('handleDetail', row)
        await request("reSend", {
          emailSendLogId: row.id
        })
        ElMessage({
          showClose: true,
          type: "success",
          message: t('system.emaillist.emailResendSuccess'),
        });
        getData();
      } catch (error) {
        console.error(error);
      }
    };
    const addNew = () => {
      // data.dialogTableVisible = true
      data.dialogFormVisible = true
      data.dialogTitle = t('system.emaillist.addEmailNotification')
    }

    getData();
    return {
      params,
      query,
      data,
      tableDataList,
      getData,
      searchData,
      updatePage,
      deleteDetail,
      handleDetail,
      addNew
    };
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
</style>
